import Axios from "axios";
import {resolveApiBaseUrl} from "@/portal/branding";
// import router from "@/router";

const axiosConfig = {
    // baseURL: "http://localhost:8000/",
    baseURL: resolveApiBaseUrl(),
    withCredentials: true
}

const axios = Axios.create(axiosConfig);
const _axios = Axios.create(axiosConfig);

axios.interceptors.response.use(
    response => response,
    async error => {
        if(error.response?.status === 401) {
            try {
                await _axios.post("auth/token/refresh/");
                return await _axios.request(error.config);
            } catch {
                // if(e.response.status === 401)
                //     await router.push({name: 'Login'});
            }
        }

        return Promise.reject(error);
    }
);

export default axios;
